import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { Panel, Empty } from "@/admin/ui";

export const AdminNews = () => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/news").then((r) => setD(r.data)).catch(() => setD({ items: [] })), []);
  useEffect(() => { load(); }, [load]);
  const refresh = () => api.post("/admin/news/refresh").then((r) => toast.success(r.data.message)).catch((e) => toast.error(errMsg(e)));
  return (
    <Panel title="News feed" sub={`New articles also add fresh questions to the daily quiz${d?.updated_at ? ` · last fetched ${fmtDateTime(d.updated_at)}` : ""}`} testid="admin-news"
      action={<button onClick={refresh} className="inline-flex h-9 items-center gap-2 rounded-full bg-[#0D3B2B] px-4 text-xs font-bold text-white" data-testid="admin-news-refresh"><RefreshCw className="h-3.5 w-3.5" />Fetch latest news</button>}>
      <div className="grid gap-3 md:grid-cols-2">
        {(d?.items || []).slice(0, 30).map((n, i) => (
          <a key={n.url || i} href={n.url} target="_blank" rel="noreferrer" className="rounded-xl border border-[#E3E6DD] p-4 transition-colors hover:border-[#2E9E6B]">
            <p className="text-[10px] font-bold uppercase tracking-wider text-[#2E9E6B]">{[n.scope, n.city, n.topic].filter(Boolean).join(" · ")}</p>
            <p className="mt-1 font-bold text-[#0D3B2B]">{n.title}</p>
            {n.summary && <p className="mt-1 line-clamp-2 text-sm text-[#4A6358]">{n.summary}</p>}
          </a>
        ))}
      </div>
      {d && !d.items.length && <Empty>No news yet. Click "Fetch latest news".</Empty>}
    </Panel>
  );
};
